/**
 * @packageDocumentation
 * @module f1/fn
 */

export interface Safe {
  /**
   * Guarantee a variable has a value by providing a fallback
   *
   * @public
   * @function f1.safe
   * @param fallback the default value if value is `null` or `undefined
   * @param value the value passed through
   * @example
   *
   * ```ts
   * safe('', 'string') === 'string'
   * safe('', undefined) === ''
   * safe('', null) === ''
   * ```
   */
  <T, V>(fallback: T | V, value?: V): T | V;
  <T, V>(fallback: T | V): (value?: V) => T | V;
}

/**
 * @see Safe
 */
export default <T, V>(fallback: T | V, value?: V): T | V => value ?? fallback;
